import { Expose } from 'class-transformer';
import { BaseEntity } from './base.entity';

export class DataEnrichedErrorResponse extends BaseEntity {
  @Expose()
  public error: string;

  @Expose()
  public data: any;
}
